import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";
//service
import DetailService from "@/core/services/detail.service.ts";
import SidebarService from "@/core/services/sidebar.service.ts";
import ReportService from "@/core/services/report.service.ts";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent,
  },
})
export default class EvaluatedDetailComponent extends Vue {
  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
  reportService: any = new ReportService();
  user_id: any = [];
  errorReport: boolean = false;
  modal: boolean = false;
  listVideo: boolean = false;
  report: boolean = false;
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modalEvaluated: boolean = false;
  error: boolean = false;
  companyList: any = [];
  profileList: any = [];
  videosList: any = [];
  name: string = "";
  companyName: string = "";
  surname: string = "";
  birthdate: string = "";
  email: string = "";
  password: string = "";
  confirm_password: string = "";
  date: string = "";
  companies: boolean = false;
  profile: string = "defaultProfile";
  expiration: string = "";
  company: string = "";
  createdAt: string = "";
  updatedAt: string = "";
  startDate1: string = "";
  startDate2: string = "";
  startDate3: string = "";
  databaseConfig: any;
  isTrainingSuperAdmin: boolean = false;
  // Surveys config
  mapSurveyId: number = 0;
  selfEvaluationSurvey: number = 0;
  initPersonalStyleSurveyDate: any;
  initCommunicationStyleSurveyDate: any;
  initMapSurveyDate: any;
  personalStylePercentage: any = 0;
  communicationStylePercentage: any = 0;
  mapPercentage: any = 0;
  skillOneScore: any = 0;
  skillOnePercentage: any = 0;
  skillTwoScore: any = 0;
  skillTwoPercentage: any = 0;
  skillThreeScore: any = 0;
  skillThreePercentage: any = 0;
  skillFourthScore: any = 0;
  skillFourthPercentage: any = 0;
  skillFivethPercentage: any = 0;
  skillFivethScore: any = 0;
  skillSixthPercentage: any = 0;
  skillSixthScore: any = 0;
  skillSevenPercentage: any = 0;
  skillSevenScore: any = 0;
  skillEigthPercentage: any = 0;
  skillEigthScore: any = 0;
  skillNinePercentage: any = 0;
  skillNineScore: any = 0;
  skillTenPercentage: any = 0;
  skillTenScore: any = 0;
  skillElevenPercentage: any = 0;
  skillElevenScore: any = 0;
  skillTwelvePercentage: any = 0;
  skillTwelveScore: any = 0;
  skillThirdteenPercentage: any = 0;
  skillThirdteenScore: any = 0;
  skillFourthteenPercentage: any = 0;
  skillFourthteenScore: any = 0;
  // Survey: Auto
  autoSkillOneScore: number = 0;
  autoSkillTwoScore: number = 0;
  autoSkillThreeScore: number = 0;
  autoSkillFourScore: number = 0;
  // Survey: Styles
  stylesSkillOneScore: number = 0;
  stylesSkillTwoScore: number = 0;
  stylesSkillThreeScore: number = 0;
  stylesSkillFourScore: number = 0;

  // section of Surveys
  introOne: string = "";
  introThree: string = "";
  introTwo: string = "";
  jaimeAdviceHugoOne: string = "";
  jesusInterviewByAna: string = "";
  juanDelegatesToJose: string = "";
  luisAndAnaOne: string = "";
  luisArguesWithJaimeOne: string = "";
  luisDelegatesToJuanOne: string = "";
  luisMeetsAnaOne: string = "";
  luisMeetsSilviaOne: string = "";
  luisPadronOne: string = "";
  managementJaimeOne: string = "";
  questionEigthTwelveOne: string = "";
  questionElevenTwelveOne: string = "";
  questionFiveTwelveOne: string = "";
  questionFourTwelveOne: string = "";
  questionNineTwelveOne: string = "";
  questionSevenTwelveOne: string = "";
  questionSixTwelveOne: string = "";
  questionTenTwelveOne: string = "";
  questionThreeTwelveOne: string = "";
  questionTwelveTwelveOne: string = "";
  questionTwoTwelveOne: string = "";
  shouldAnaHireJesusOne: string = "";
  silviAndJaimeOne: string = "";
  silviaMemorandumOne: string = "";

  mounted() {
    const _ = this;
    _.getByCandidates();
    _.getCompanies();
    _.isTrainingAdmin();
  }

  getVideos() {
    const _ = this;
    const resourcesCollection = _.databaseConfig.collection("resourceWasWatch");
    console.log(_.user_id, "id");
    resourcesCollection
      .where("userId", "==", _.user_id)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(doc.data(), "here");
          _.videosList = doc.data();
          let videoListProperties = Object.keys(doc.data());
          console.log(videoListProperties);
        });
      })
      .catch((err) => {
        console.log(err, " Err");
      });
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  filterDate(date = "") {
    const _ = this;
    if (date != null && date != "") {
      date = date.split("T");
      date = date[0];
    }
    return date;
  }

  filterTime(time: any = "") {
    const _ = this;
    if (time != null && time != "") {
      time = time.split("T");
      time = time[1];
      time = time.split(".");
      time = time[0];
    }
    return time;
  }

  getSurveyAnswers() {
    const _ = this;
    _.detailService
      .getSurveyResults(_.user_id)
      .then((data: any) => {
        const skills = [
          { id: 1, name: "One" },
          { id: 2, name: "Two" },
          { id: 3, name: "Three" },
          { id: 4, name: "Four" },
          { id: 5, name: "Five" },
          { id: 6, name: "Six" },
          { id: 7, name: "Seven" },
          { id: 8, name: "Eight" },
          { id: 9, name: "Nine" },
          { id: 10, name: "Ten" },
          { id: 11, name: "Eleven" },
          { id: 12, name: "Twelve" },
          { id: 13, name: "Thirteen" },
          { id: 14, name: "Fourteen" },
        ];

        skills.forEach((skill) => {
          const skillPropScore = `skill${skill.name}Score`;
          const percentagePropName = `skill${skill.name}Percentage`;
          const skillObj = data["data"].report.map.find((obj: any) => obj.id === skill.id);
          _[percentagePropName] = skillObj ? skillObj.percentage :  0;
          _[skillPropScore] = skillObj ? skillObj.value : 0;
        });
      
        // Survey: Auto -> Scores
        for (let i = 0; i < data["data"].report.auto.length; i++) {
          if (data["data"].report.auto[i].id == 1) {
            _.autoSkillOneScore = data["data"].report.auto[i].score;
          }
          if (data["data"].report.auto[i].id == 2) {
            _.autoSkillTwoScore = data["data"].report.auto[i].score;
          }
          if (data["data"].report.auto[i].id == 3) {
            _.autoSkillThreeScore = data["data"].report.auto[i].score;
          }
          if (data["data"].report.auto[i].id == 4) {
            _.autoSkillFourScore = data["data"].report.auto[i].score;
          }
        }
        // Survey: Communication -> Scores
        for (let i = 0; i < data["data"].report.communication.length; i++) {
          if (data["data"].report.communication[i].id == 5) {
            _.stylesSkillOneScore = data["data"].report.communication[i].score;
          }
          if (data["data"].report.communication[i].id == 6) {
            _.stylesSkillTwoScore = data["data"].report.communication[i].score;
          }
          if (data["data"].report.communication[i].id == 7) {
            _.stylesSkillThreeScore =
              data["data"].report.communication[i].score;
          }
          if (data["data"].report.communication[i].id == 8) {
            _.stylesSkillFourScore = data["data"].report.communication[i].score;
          }
        }
      })
      .catch((err) => {
        if (err.response.data.message.includes("Invalid or inexistent user")) {
          localStorage.removeItem("tk_auth");
          _.logInModal = true;
        }
      });
  }

  getCompanies() {
    const _ = this;
    _.isLoading = true;
    _.detailService
      .getCompanies()
      .then((data: any) => {
        _.companyList = data["data"].companies;
        _.companyList.sort(function(a, b) {
          var textA = a.name.toLowerCase();
          var textB = b.name.toLowerCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
      });
  }

  singleReport(user_id) {
    const _ = this;
    _.$router.push(`/single-report/${user_id}`);
  }

  getByCandidates() {
    const _ = this;
    _.user_id = location.href.split("/");
    _.user_id = _.user_id[5];
    _.isLoading = true;
    _.detailService
      .getByCandidates(_.user_id)
      .then((data: any) => {
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
        _.getSurveyAnswers();
        _.name = data["data"].candidate.name;
        _.surname = data["data"].candidate.surname;
        _.birthdate = data["data"].candidate.birthdate;
        _.email = data["data"].candidate.email;
        _.createdAt = data["data"].candidate.createdAt;
        _.updatedAt = data["data"].candidate.updatedAt;
        _.companyName =
        data["data"].candidate.company != null
        ? data["data"].candidate.company.name
        : null;
        _.mapSurveyId = data["data"].candidate.batches[0].surveys[0].id;
        _.startDate1 = data["data"].candidate.batches[0].surveys[0].startDate;
        _.startDate2 = data["data"].candidate.batches[0].surveys[1].startDate;
        _.startDate3 = data["data"].candidate.batches[0].surveys[2].startDate;
        _.mapPercentage = data["data"].candidate.batches[0].surveys[0].surveyProgress;
        _.personalStylePercentage = data["data"].candidate.batches[0].surveys[1].surveyProgress;
        _.communicationStylePercentage = data["data"].candidate.batches[0].surveys[2].surveyProgress;
      })
      .catch((err: any) => {
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      });
  }

  private isTrainingAdmin() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    if (companyId === "null" || companyId === "1") {
      _.isTrainingSuperAdmin = true;
    }
  }
}
